export const CON_API_URL = '/api/';

// export const BOOK_ID_OFF = "B000000000";
// export const BOOK_ID_OFFICE_WORK = "B000000001";

export const AUTHORIZATION_SERVER = "gpay.jp";
